export default {
	active_campaigns: "Campañas en línea ",
	begin_date: "Fecha de Inicio",
	campaign: "Campaña",
	end_date: "Fecha de cierre",
	learn_more_about_the_campaign_by_clicking: "Obtenga más información sobre la campaña haciendo clic en",
	no_campaigns_found: "No se encontraron campañas.",
	previous_campaigns: "Campañas anteriores",
	view_campaign: "Ver Campaña",
}